import { AtiraRoute } from '../AtiraRoute';
import { AtiraRouteAdmin } from '../AtiraRouteAdmin';
import { Layout } from '../Layout';
import { QRRoute } from '../QR-generator/QRRoute';
import { AdminRoute } from '../admin/AdminRoute';
import { AnalyticsRouteWithLazy } from '../analytics/AnalyticsRouteWithLazy';
import { Dashboard } from '../dashboard/Dashbord';
import { AtiraLinkRoute } from '../my-link/AtiraLinkRoute';
import { SettingsRoute } from '../settings/SettingsRoute';
import { SubscriptionRoute } from '../subscription/SubscriptionRoute';
import { URLRoute } from '../url/URLRoute';
import { ErrorBoundary } from './RotuerError';

export const PrivateRouter = [
  {
    element: <Layout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/dashboard',
        element: <AtiraRoute component={<Dashboard />} />,
      },
      {
        path: '/my-link',
        element: <AtiraRoute component={<AtiraLinkRoute />} />,
      },
      {
        path: '/my-urls',
        element: <AtiraRoute component={<URLRoute />} />,
      },
      {
        path: '/my-qrs',
        element: <AtiraRoute component={<QRRoute />} />,
      },
      {
        path: '/analytics',
        element: <AtiraRoute component={<AnalyticsRouteWithLazy />} />,
      },
      {
        path: '/admin',
        element: <AtiraRouteAdmin component={<AdminRoute />} />,
      },
      {
        path: '/settings',
        element: <AtiraRoute component={<SettingsRoute />} />,
      },
      {
        path: '/subscription',
        element: <AtiraRoute component={<SubscriptionRoute />} />,
      },
    ],
  },
];
